/* ------------------------------------------------------------------
   Mr Football - THE HAT-TRICK on the product page: tiers + funnel.
   Markup in snippets/mf-hat-trick-pdp.liquid.

   THE FUNNEL
   ----------
   Tapping a tier sets the quantity, which is the fast path when someone
   wants the same shirt more than once. But the offer is "any 2 kits,
   3rd free", and quantity alone can only ever sell three of the SAME
   shirt. So choosing 2 or 3 opens a second step:

     tier 2 or 3  ->  "need 1/2 more"  ->  tap a category
     ->  this kit is added to the cart  ->  land in that category
     ->  pick the next one  ->  the cart counts down to the free kit

   Clicking a category adds the CURRENT kit (quantity 1, not the tier
   number - they are going to pick the others themselves) and then
   navigates. Quantity is reset to 1 first so the shopper does not end
   up with three of this shirt AND two more from the category.

   THE SIZE GATE IS RESPECTED. If the kit builder is still locked, the
   shopper has not chosen a size, so a category tap scrolls them back to
   the swatches instead of adding a size they never picked. Printed
   shirts cannot be exchanged, so this matters.

   WHY LISTENERS ARE DELEGATED ON document
   The theme re-renders its variant container on every size change, and
   mf-kit-builder.js then moves this block out to section level and bins
   the fresh copy. A listener bound to a tile would die with whichever
   node got binned. Delegation survives all of it.

   WHICH QUANTITY INPUT
   There are several inputs named `quantity` on a product page; most are
   hidden ones belonging to other forms. We only write to the VISIBLE one
   inside .product__section--qty, and fire both `input` and `change` so
   the theme's own quantity widget keeps in step.

   Nothing here applies a discount. THE HAT-TRICK is a real Shopify
   automatic discount scoped to the `hat-trick` collection; this only
   helps the shopper reach a basket that triggers it.
------------------------------------------------------------------ */
(function () {
  'use strict';
  if (window.__mfHatTrick) { return; }
  window.__mfHatTrick = true;

  function qtyInput() {
    var box = document.querySelector('.product__section--qty');
    if (!box) { return null; }
    var inputs = box.querySelectorAll('input[name="quantity"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].offsetParent !== null) { return inputs[i]; }
    }
    return inputs[0] || null;
  }

  function setQty(n) {
    var el = qtyInput();
    if (!el) { return; }
    var set = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
    set.call(el, String(n));
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* The id the theme would post. URL wins once a size has been tapped,
     otherwise fall back to the form that owns the visible buy button. */
  function variantId() {
    try {
      var v = new URLSearchParams(window.location.search).get('variant');
      if (v) { return v; }
    } catch (e) {}
    var btn = null;
    var all = document.querySelectorAll('.AddtoCart');
    for (var i = 0; i < all.length; i++) {
      if (all[i].offsetParent !== null) { btn = all[i]; break; }
    }
    var form = btn && btn.closest ? btn.closest('form[action="/cart/add"]') : null;
    if (!form) { return null; }
    var ids = form.querySelectorAll('[name="id"]');
    for (var j = ids.length - 1; j >= 0; j--) {
      if (ids[j].value) { return ids[j].value; }
    }
    return null;
  }

  function mark(qty) {
    var tiers = document.querySelectorAll('[data-mf-ht-qty]');
    for (var i = 0; i < tiers.length; i++) {
      var mine = tiers[i].getAttribute('data-mf-ht-qty') === String(qty);
      tiers[i].setAttribute('aria-pressed', mine ? 'true' : 'false');
    }
    var mix = document.querySelector('[data-mf-ht-mix]');
    if (!mix) { return; }
    var n = parseInt(qty, 10) || 1;
    mix.hidden = n < 2;
    var lead = mix.querySelector('[data-mf-ht-mix-lead]');
    if (lead) {
      var need = n - 1;
      lead.textContent = need === 1 ? 'One more kit to go.' : need + ' more kits to go.';
    }
  }

  function sizeStillUnchosen() {
    var kb = document.querySelector('[data-mf-kit-builder]');
    return !!(kb && kb.classList.contains('is-locked'));
  }

  function nudgeToSize() {
    var sw = document.querySelector('.swatches__option-name') ||
             document.querySelector('.swatch-element');
    if (sw && sw.scrollIntoView) { sw.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
  }

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) { return; }

    var tier = t.closest('[data-mf-ht-qty]');
    if (tier) {
      ev.preventDefault();
      var qty = parseInt(tier.getAttribute('data-mf-ht-qty'), 10) || 1;
      setQty(qty);
      mark(qty);
      return;
    }

    var chip = t.closest('[data-mf-ht-go]');
    if (chip) {
      ev.preventDefault();
      var href = chip.getAttribute('href');

      if (sizeStillUnchosen()) { nudgeToSize(); return; }

      var id = variantId();
      if (!id) { window.location.href = href; return; }

      setQty(1);
      chip.style.opacity = '.6';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
      }).catch(function () { return null; })
        .then(function () { window.location.href = href; });
    }
  }, false);

  /* If the shopper edits the quantity box directly, keep the tiers and
     the follow-on step honest rather than leaving a stale one lit. */
  document.addEventListener('change', function (ev) {
    var t = ev.target;
    if (!t || t.name !== 'quantity') { return; }
    if (!t.closest || !t.closest('.product__section--qty')) { return; }
    mark(parseInt(t.value, 10) || 0);
  }, false);
})();
